'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getCookieCurrentPlace } from '@/features/place/cookies/cookie-current-place';
import calculateDistance from '@/features/place/utils/calculate-distance';
import InputSlider from '@/ui/form-elements/input-range-slider/input-slider';
import styles from './listing-radius-filter.module.scss';
interface ListingRadiusFilterProps {
  setFilterLink: (link: {
    pathname: string;
    searchParams: URLSearchParams;
  }) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  };
}
export default function ListingRadiusFilter(props) {
  const $ = _c(21);
  const {
    filterLink,
    setFilterLink
  } = props;
  let t0;
  if ($[0] !== filterLink.searchParams) {
    t0 = filterLink.searchParams.get("search_params.geo.radius_scale") ?? 1;
    $[0] = filterLink.searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentDistance = Number(t0);
  const [selectedScale, setSelectedScale] = useState(currentDistance);
  const [distance, setDistance] = useState(null);
  let t1;
  let t2;
  if ($[2] !== selectedScale) {
    t1 = () => {
      const currentPlace = getCookieCurrentPlace();
      const calculateFilterDistance = scale => {
        const placeDistance = currentPlace?.bbox ? calculateDistance(currentPlace.bbox) : 40;
        const kmRadius = Number((placeDistance * Number(scale) / 2).toFixed(1));
        const miRadius = (kmRadius * 0.621371).toFixed(1);
        return `${miRadius} mi / ${String(kmRadius)} km`;
      };
      setDistance(calculateFilterDistance(selectedScale));
    };
    t2 = [selectedScale];
    $[2] = selectedScale;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== filterLink.searchParams) {
    t3 = () => {
      setSelectedScale(Number(filterLink.searchParams.get("search_params.geo.radius_scale") ?? 1));
    };
    $[5] = filterLink.searchParams;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== filterLink) {
    t4 = [filterLink];
    $[7] = filterLink;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== filterLink.pathname || $[10] !== filterLink.searchParams || $[11] !== setFilterLink) {
    t5 = value => {
      filterLink.searchParams.set("search_params.geo.radius_scale", String(value / 10));
      setSelectedScale(value / 10);
      setFilterLink({
        pathname: filterLink.pathname,
        searchParams: filterLink.searchParams
      });
    };
    $[9] = filterLink.pathname;
    $[10] = filterLink.searchParams;
    $[11] = setFilterLink;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const creteNewSearchParams = t5;
  let t6;
  if ($[13] !== distance) {
    t6 = <div className={styles.listingRadiusFilter__label}>{distance}</div>;
    $[13] = distance;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = selectedScale * 10;
  let t8;
  if ($[15] !== creteNewSearchParams || $[16] !== t7) {
    t8 = <InputSlider min={1} max={20} value={t7} onChange={creteNewSearchParams} />;
    $[15] = creteNewSearchParams;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div>{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}